module.exports = __webpack_public_path__ + "img/schedule.ad062bca.svg";